/** Chiave di un Documento del gestionale, come la portano i pezzi dell'RMA
 *  (`docTipork`…) e le note di credito (`tipork`…). */
export interface ChiaveDocumento {
  tipork: string;
  anno: number;
  serie?: string | null;
  numdoc: number;
}

/** La pagina del Documento nell'area clienti. */
export function hrefDocumento(k: ChiaveDocumento): string {
  return `/area-clienti/documenti/${k.tipork}/${k.anno}/${encodeURIComponent(k.serie || ' ')}/${k.numdoc}`;
}

/** I Documenti d'origine dei pezzi di un RMA, uno per chiave e in ordine di
 *  apparizione: un RMA può mettere insieme pezzi di più Documenti. */
export function documentiOrigine(items: any[] | undefined): (ChiaveDocumento & { numero: string })[] {
  const visti = new Map<string, ChiaveDocumento & { numero: string }>();
  for (const it of items ?? []) {
    if (!it.docTipork || !it.docNumdoc) continue;
    const k = { tipork: it.docTipork, anno: it.docAnno, serie: it.docSerie, numdoc: it.docNumdoc };
    const id = `${k.tipork}/${k.anno}/${k.serie}/${k.numdoc}`;
    if (!visti.has(id)) visti.set(id, { ...k, numero: numeroOrigine(k) });
  }
  return Array.from(visti.values());
}

/** "B/2025/3727", con la serie se c'è: come il numero sul pezzo. */
export function numeroOrigine(k: ChiaveDocumento): string {
  const serie = (k.serie || '').trim();
  return [k.tipork, k.anno, serie, k.numdoc].filter(v => v !== undefined && v !== null && v !== '').join('/');
}
